"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const ClickableItemCard_1 = require("@Components/ClickableItemCard");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const rightsholder_contact_type_1 = require("@App/helpers/rightsholder-contact-type");
/**
 * TODO This component needs unit testing once DI has been removed
 *
 * @param props
 * @constructor
 */
const RightsholderContactTable = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { popupStore, contactStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const handleOnClick = (event) => __awaiter(void 0, void 0, void 0, function* () {
        if (event.currentTarget.id) {
            const selectedContact = props.rightsholderContacts.find((contact) => contact.id === event.currentTarget.id);
            if (selectedContact) {
                contactStore.setRightsholderContact(selectedContact);
            }
            else {
                popupStore.setAlertData('Unable To Find Rightsholder Contact', true);
                navigate('/');
            }
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, props.rightsholderContacts.map((contact) => (react_1.default.createElement(ClickableItemCard_1.ClickableItemCard, { className: 'rightsholder-contact-item', path: navigation_1.default.rightholder.maintenance.contactInformation(contact.ipId, contact.id), id: contact.id, handleOnClick: handleOnClick, key: contact.id },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'left-data' },
                react_1.default.createElement("div", { className: 'contact-title' },
                    react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.maintenance.contactInformation(contact.ipId, contact.id), id: contact.id, 
                        /*
                         * These e.stopPropagation() calls are apparently hacks enabled to
                         * keep the history working properly. I currently don't know a
                         * better solution - Dan
                         */
                        onClick: (e) => e.stopPropagation(), onMouseDown: (e) => {
                            e.stopPropagation();
                            return handleOnClick(e);
                        }, className: 'title-link' },
                        contact.firstName,
                        " ",
                        contact.lastName))),
            react_1.default.createElement("div", { className: 'middle-data' },
                "Email: ",
                react_1.default.createElement("strong", null, contact.email)),
            react_1.default.createElement("div", { className: 'right-data' },
                "Contact Type:",
                ' ',
                react_1.default.createElement("strong", null, (0, rightsholder_contact_type_1.getRightsholderContactType)(contact.rightsholderContactTypeId)))))))));
};
exports.default = RightsholderContactTable;
